var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.patient && _vm.patient.excluded)?_vm._t("excluded",[_c('after-screening'),_c('after-interview')]):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }